import { useContext } from 'react';

import TickIcon from 'assets/icons/tick.svg';
import CompareIcon from 'assets/icons/compare.svg';
import { CompareContext } from '@providers/CompareProvider';
import IconWithBadge from '@components/IconWithBadge';
import NoSSR from '@misc/NoSSR';
import cssVar from 'utils/cssVar';

type Props = {
  id: number;
  productTypeId: number;
};

const AddToCompare = ({ id, productTypeId }: Props): JSX.Element => {
  const { isInCompare, addToCompare, removeFromCompare } = useContext(CompareContext);

  const isAddedToCompare = isInCompare(id, productTypeId);

  return (
    <NoSSR>
      <div
        onClick={(e) => {
          e.preventDefault();

          if (isAddedToCompare) {
            removeFromCompare(id, productTypeId);
          } else {
            addToCompare(id, productTypeId);
          }
        }}
      >
        <IconWithBadge
          icon={CompareIcon}
          badgeColor={cssVar('activeColor')}
          badgeText={isAddedToCompare ? <TickIcon fill="white" /> : undefined}
        />
      </div>
    </NoSSR>
  );
};

export default AddToCompare;
